export const COUNTRIES = [
  { id: 'india', name: 'India', code: 'IN' },
  { id: 'philippines', name: 'Philippines', code: 'PH' },
  { id: 'pakistan', name: 'Pakistan', code: 'PK' },
  { id: 'united states', name: 'United States', code: 'US' },
  { id: 'united kingdom', name: 'United Kingdom', code: 'GB' },
  { id: 'canada', name: 'Canada', code: 'CA' },
  { id: 'australia', name: 'Australia', code: 'AU' },
  { id: 'germany', name: 'Germany', code: 'DE' },
  { id: 'france', name: 'France', code: 'FR' },
  { id: 'japan', name: 'Japan', code: 'JP' },
  { id: 'china', name: 'China', code: 'CN' },
  { id: 'brazil', name: 'Brazil', code: 'BR' },
  { id: 'mexico', name: 'Mexico', code: 'MX' },
  { id: 'spain', name: 'Spain', code: 'ES' },
  { id: 'italy', name: 'Italy', code: 'IT' }
];

export const INDIAN_LANGUAGES = [
  { id: 'malayalam', name: 'Malayalam', nativeName: 'മലയാളം' },
  { id: 'hindi', name: 'Hindi', nativeName: 'हिन्दी' },
  { id: 'tamil', name: 'Tamil', nativeName: 'தமிழ்' },
  { id: 'telugu', name: 'Telugu', nativeName: 'తెలుగు' },
  { id: 'kannada', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  { id: 'bengali', name: 'Bengali', nativeName: 'বাংলা' },
  { id: 'gujarati', name: 'Gujarati', nativeName: 'ગુજરાતી' },
  { id: 'marathi', name: 'Marathi', nativeName: 'മરાઠી' },
  { id: 'punjabi', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ' },
  { id: 'urdu', name: 'Urdu', nativeName: 'اردو' },
  { id: 'assamese', name: 'Assamese', nativeName: 'অসমীয়া' },
  { id: 'oriya', name: 'Oriya', nativeName: 'ଓଡ଼ିଆ' }
];

export const getCountryName = (id) => {
  const match = COUNTRIES.find(c => c.id === id);
  return match ? `${match.name} (${match.code})` : id;
};

export const getLanguageName = (id) => {
  const match = INDIAN_LANGUAGES.find(l => l.id === id);
  return match ? match.name : id;
};

export const USER_ACTION_TYPE_COLORS = {
  'edit_profile': 'blue',
  'view_cart': 'green',
  'add_to_cart': 'green',
  'view_homepage': 'orange',
  'view_order_history': 'purple',
  'view_order_detail': 'purple',
  'view_addresses': 'blue',
  'edit_address': 'blue',
  'delete_address': 'red',
  'add_address': 'green',
  'product_enquiry': 'orange',
  'view_coupons': 'purple',
  'apply_coupon': 'green',
  'view_product_list': 'orange',
  'place_order': 'green',
  'view_categories': 'orange',
  'view_category_products': 'orange',
  'view_search_products': 'orange',
  'view_coin_history': 'purple',
};

export const USER_ACTION_ATTRIBUTES = {
  POPUP_SHOWN: "popup_shown",
  APPLICABLE_COUPON_SHOWN: "applicable_coupon_shown",
};

export const formatAttributeName = (attribute) => {
  return attribute
    .replace(/_/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase());
};